module.exports = __webpack_public_path__ + "static/media/PsyButImg.e220bb38.jpg";